import { connect } from 'react-redux';

import LoginForm from 'components/LoginForm/index';
import { loginUser, googleLoginUser, facebookLoginUser } from 'services/auth/actions';
import { emailChanged, passwordChanged } from '../actions';

const mapStateToProps = ({ scene, auth }) => {
  return {
    email: scene.login.email,
    password: scene.login.password,
    loading: auth.loading,
    error: auth.error
  };
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onEmailChange: (text) => { dispatch(emailChanged(text)) },
    onPasswordChange: (text) => { dispatch(passwordChanged(text)) },
    loginFacebook: () => { dispatch(facebookLoginUser()) },
    loginGoogle: () => { dispatch(googleLoginUser()) },
    loginUser: (email, password) => {
      dispatch(loginUser(email, password, ownProps.from))
    }
  };
}

const FirebaseLoginForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);
export default FirebaseLoginForm



// WEBPACK FOOTER //
// ./src/scenes/Login/components/FirebaseLoginForm.js